import { Suspense } from 'react';
import type { Container } from 'react-dom/client';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'uikit';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import { TokenHandler } from '../src/pages/security/TokenHandler';
import App from './App';
import './assets/styles/index.scss';
import MuiXLicense from './components/MuiXLicense';
import i18n from './i18n/i18n';
import {
  chooseInitialLanguage,
  fetchSupportedLanguages,
  saveLanguage,
} from './i18n/languageService';
import store from './store/store';
import './utils/filterReactWarnings';

// loads the Icon plugin
// eslint-disable-next-line react-hooks/rules-of-hooks
UIkit.use(Icons);

async function init() {
  try {
    const supported = await fetchSupportedLanguages();
    const initial = chooseInitialLanguage(supported);
    await i18n.changeLanguage(initial);
    saveLanguage(initial);
  } catch (e) {
    await i18n.changeLanguage('fr-FR');
  } finally {
    const root = ReactDOM.createRoot(
      document.getElementById('root') as Container
    );
    root.render(
      <Suspense fallback={<div>Loading translations...</div>}>
        <Provider store={store}>
          <BrowserRouter>
            <TokenHandler>
              <App />
            </TokenHandler>
          </BrowserRouter>
          <MuiXLicense />
        </Provider>
      </Suspense>
    );
  }
}

init();
